



















































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import MappingDefaultsEditDialog from '@/components/Products/ProductGeneralLedger/MappingDefaultsEditDialog.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'MappingDefaults', components: { MappingDefaultsEditDialog } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get generalLedgerMappingsEnabled() {
        // If the product general ledger mapping settings exist (when the ID is present) then check the enabled setting
        if (this.generalLedgerMappings.id) {
            return this.generalLedgerMappings.enabled;
        }
        // Else return false as not enabled
        else {
            return false;
        }
    }

    get generalLedgerMappings() {
        return ProductDetailsModule.generalLedgerMappings;
    }

}
